// extracted by css-extract-rspack-plugin
export default {"root":"SegmentEditor-module__root___dh_TS"};